<div class="flex row p-2 justify-between">
    <div class="text-lg font-medium tracking-tight leading-6 truncate">
        Edit MAWOP
    </div>
</div>
<hr class="my-0">

<mat-dialog-content>
    <form [formGroup]="casingform" class="w-full grid grid-cols-2 gap-2">
            <mat-label>Tubing Casing </mat-label>
            <mat-form-field class="custom-mat-form-field w-full">
                <input type="number" matInput formControlName="tubing" />
                <span matTextSuffix>in</span>

            </mat-form-field>

            <mat-label>Production Casing</mat-label>
            <mat-form-field class="custom-mat-form-field w-full">
                <input type="number" matInput formControlName="production" />
                <span matTextSuffix>in</span>
            </mat-form-field>

            <mat-label>Intermediate Casing</mat-label>
            <mat-form-field class="custom-mat-form-field w-full">
                <input type="number" matInput formControlName="intermediate" />
                <span matTextSuffix>in</span>
            </mat-form-field>

            <mat-label>Surface Casing</mat-label>
            <mat-form-field class="custom-mat-form-field w-full">
                <input type="number" matInput formControlName="surface" />
                <span matTextSuffix>in</span>
            </mat-form-field>

            <mat-label>Conductor Casing</mat-label>
            <mat-form-field class="custom-mat-form-field w-full">
                <input type="number" matInput formControlName="conductor" />
                <span matTextSuffix>in</span>
            </mat-form-field>
    </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button class="btn btn-outline btn-error mx-4" mat-dialog-close>Cancel</button>
    <button class="btn btn-primary" (click)="updateMAWOP()">Update</button>
</mat-dialog-actions>

<ng-template #closedIcon>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
        class="w-6 h-6">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
    </svg>
</ng-template>